import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZoomIn = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", { d: "m42.184 37.942-9.365-9.364a14.56 14.56 0 0 0 2.391-8.004c0-8.083-6.553-14.636-14.636-14.636S5.937 12.49 5.937 20.574 12.49 35.21 20.573 35.21c2.956 0 5.702-.883 8.003-2.39l9.365 9.364zM8.937 20.574c0-6.417 5.22-11.636 11.636-11.636s11.636 5.22 11.636 11.636-5.22 11.636-11.636 11.636S8.937 26.99 8.937 20.574" }),
		/* @__PURE__ */ _jsx("path", { d: "M19.074 12.644h3v15.859h-3z" }),
		/* @__PURE__ */ _jsx("path", { d: "M12.644 19.073h15.86v3h-15.86z" })
	] }) })
});
export default SvgZoomIn;
